// extracted by mini-css-extract-plugin
var _1 = "Tabs_activeTab__08696";
var _2 = "Tabs_arrowLeft__dfcc6";
var _3 = "Tabs_arrowRight__b13ee";
var _4 = "Tabs_content__d0884";
var _5 = "Tabs_contentPosition__7f305";
var _6 = "Tabs_controls__a7ea0";
var _7 = "Tabs_grow__07dea";
var _8 = "Tabs_isDrawArrow__b002c";
var _9 = "Tabs_left__9e5f2";
var _a = "Tabs_right__51193";
var _b = "Tabs_root__45878";
var _c = "Tabs_tabBarExtraContentGrow__ba468";
var _d = "Tabs_tabList__9aac3";
var _e = "Tabs_tabListWrap__83961";
var _f = "Tabs_tabsGrow__6cf1c";
export { _1 as "activeTab", _2 as "arrowLeft", _3 as "arrowRight", _4 as "content", _5 as "contentPosition", _6 as "controls", _7 as "grow", _8 as "isDrawArrow", _9 as "left", _a as "right", _b as "root", _c as "tabBarExtraContentGrow", _d as "tabList", _e as "tabListWrap", _f as "tabsGrow" }
